import { timerTaskId } from '../../taskTimer';

export interface TimerEntry {
    taskId: string;
    isTimerActive: boolean;
    startTime: number | null;
    runTime?: number;
}
export interface PendingTimerSave {
    taskId: string;
    startTime: number | null;
    endTime: number;
    before: number;
    seconds: number;
}
const initialState = {
    stopWatchesData: [] as TimerEntry[], initialized: false, busy: false,
    revision: 0, changes: 0, syncedAt: 0, stale: false, error: '', pendingSave: null as PendingTimerSave | null,
};

export const stopWatchesDataReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA_USER_ACCOUNT_LOGOUT':
        case 'timer/reset':
            return { ...initialState, revision: state.revision + 1 };
        case 'timer/changed':
            return { ...state, changes: state.changes + 1, syncedAt: Date.now() };
        case 'timer/busy':
            return { ...state, busy: action.payload };
        case 'timer/stale':
            return { ...state, stale: true, revision: state.revision + 1 };
        case 'timer/error':
            return { ...state, error: action.payload, stale: !!action.payload || state.stale };
        case 'timer/pending':
            return { ...state, pendingSave: action.payload };
        case 'timer/snapshot':
            if (action.revision !== state.revision) return state;
            return { ...state, initialized: true, syncedAt: Date.now(), stale: false, revision: state.revision + 1,
                stopWatchesData: action.payload };
        case 'IS_TIMER_COLLAPSED_RESULTS':
        case 'ACTIVATE_TIMER': {
            const taskId = timerTaskId(action.payload.taskId);
            if (!taskId) return state;
            const previous = state.stopWatchesData.find(t => t.taskId === taskId);
            const entry = { ...previous, ...action.payload, taskId };
            const others = state.stopWatchesData.filter(t => t.taskId !== taskId)
                .map(t => entry.isTimerActive ? { ...t, isTimerActive: false } : t);
            return { ...state, revision: state.revision + 1, stopWatchesData: [...others, entry] };
        }
        case 'REMOVE_TIMER':
            return { ...state, revision: state.revision + 1,
                stopWatchesData: state.stopWatchesData.filter(t => t.taskId !== timerTaskId(action.payload)) };
        default:
            return state;
    }
};

export const loadRunTimeResults = (payload: TimerEntry) => ({ type: 'IS_TIMER_COLLAPSED_RESULTS', payload });
export const activateTimer = (payload: { taskId: any; isTimerActive: boolean; startTime?: number | null; runTime?: number }) => ({ type: 'ACTIVATE_TIMER', payload });
export const removeTimer = (payload: any) => ({ type: 'REMOVE_TIMER', payload });
